import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=40bcd880&scoped=true"
import script from "./TaskList.vue?vue&type=script&lang=ts"
export * from "./TaskList.vue?vue&type=script&lang=ts"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=40bcd880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bcd880",
  null
  
)

export default component.exports